// extracted by mini-css-extract-plugin
module.exports = {"container":"CryptoChart_container__2d-Mu"};